import { useQuery } from "@tanstack/react-query";
import { getExpenseAndIncomeCategory } from "src/services/ExpenseAndIncomeCategory.service";
import { ExpenseAndIncomeCategoryParams } from "./interfaces";
import { useGetAccessPermission } from "src/hooks/useGetAccessPermission";
import { AccessResource, ActionType } from "src/types/accessControl";

export const useGetExpenseAndIncomeCategory = (
  params: ExpenseAndIncomeCategoryParams
) => {
  const isAllowedExpenseAndIncome = useGetAccessPermission({
    resource: AccessResource["Master Data - Expense and Income Category"],
    action: ActionType["Read"],
  });
  return useQuery({
    queryKey: ["expense-and-income-category", params],
    queryFn: () => getExpenseAndIncomeCategory(params),
    retry: false,
    enabled: isAllowedExpenseAndIncome,
  });
};
